import script from "./MappingRule.vue?vue&type=script&setup=true&lang=js"
export * from "./MappingRule.vue?vue&type=script&setup=true&lang=js"

import "./MappingRule.vue?vue&type=style&index=0&id=5d304ac0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d304ac0"]])

export default __exports__